export const fileReaderPromise = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = function(e) {
      resolve(e.target.result)
    }

    reader.onerror = function(e) {
      reject(e)
    }

    reader.readAsDataURL(file)
  })
}


export const extractBase64FromFileData = dataString => {
  return dataString.replace(/data:[^;]*;base64,/,'')
}
 
export const base64ToArrayBuffer = base64 => {
  var binary_string = window.atob(base64)
  var len = binary_string.length
  var bytes = new Uint8Array(len)
  for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i)
  }
  return bytes.buffer
}

export const base64ToUint8Array = base64 => {
  var binary_string = window.atob(base64)
  var len = binary_string.length
  var bytes = new Uint8Array(len)
  for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i)
  }
  return bytes
}

export const arrayBufferToBase64 = buffer => {
  let bytes = buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer)
  let chunkSize = 0x8000
  let binary = ''

  for (let i = 0; i < bytes.length; i += chunkSize)
  {
    let chunk = bytes.subarray(i, i + chunkSize)
    binary += String.fromCharCode.apply(null, chunk)
  }

  return window.btoa(binary)
}

export const normaliseBinaryPayload = payload => {
  if (!payload)
  {
    return new Uint8Array()
  }

  if (payload instanceof Uint8Array)
  {
    return payload
  }

  if (payload instanceof ArrayBuffer)
  {
    return new Uint8Array(payload)
  }

  if (Array.isArray(payload))
  {
    return Uint8Array.from(payload)
  }

  if (typeof payload === 'object' && payload.type === 'Buffer' && Array.isArray(payload.data))
  {
    return Uint8Array.from(payload.data)
  }

  if (typeof payload === 'string')
  {
    return base64ToUint8Array(payload)
  }

  return new Uint8Array(payload)
}

export const printIframeDocument = (iframe, delay = 250) => {
  return new Promise(resolve => {
    if (!iframe) {
      resolve()
      return
    }

    const triggerPrint = () => {
      setTimeout(() => {
        try {
          iframe.contentWindow.focus()
          iframe.contentWindow.print()
        }
        catch (err) {
          console.log("print iframe error", err)
        }
        resolve()
      }, delay)
    }

    iframe.onload = triggerPrint

    try {
      if (iframe.contentWindow && iframe.contentDocument && iframe.contentDocument.readyState === 'complete') {
        triggerPrint()
      }
    }
    catch (err) {
      console.log("print iframe readyState error", err)
    }
  })
}

export const sleep = ms => {
  return new Promise(resolve => setTimeout(resolve, ms))
}
